import { render, staticRenderFns } from "./ManualRequests.vue?vue&type=template&id=70b588a8&"
import script from "./ManualRequests.vue?vue&type=script&lang=js&"
export * from "./ManualRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports